module.exports = __webpack_public_path__ + "static/media/star.8c720055.svg";